// 封装请求
import { request } from '@umijs/max'
import { message } from 'antd'
import qs from 'qs'
import { getToken } from './token'

const API = {
  production: 'https://api.md5.zhuanqq.com', // 生产环境地址
  test: 'https://192.168.0.104:8081', // 测试环境地址
  dev: '/api', // 开发环境地址（通过代理转发到后端服务器）
}

const env = process.env.UMI_ENV as keyof typeof API
console.log(env)

const baseUrl = API[env]

const apiUrl = '/admin/v1'

export default async function requestData<T>(url: string, options: { [key: string]: any } = {}) {
  const token = getToken()

  return request<API.RequestRes<T>>(`${baseUrl}${apiUrl}${url}`, {
    ...options,
    headers: { Authorization: `Bearer ${token}`, ...options.headers },
    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
  }).then((res) => {
    // 🔍 判断是否是 Blob（二进制流）
    if (res instanceof Blob) {
      // ✅ 返回 Blob 文件，交由调用方处理下载逻辑
      return res as T
    }

    if (res.code === 0) {
      return res.data
    }

    const error = new Error(res?.msg || '请求失败', { cause: res }) as Error & { notified?: boolean }
    error.notified = true
    message.error(error.message)
    throw error
  })
}
